import { bookingCompleteBookingSuccess } from '@actions/booking.action';
import { Action, createReducer, on } from '@ngrx/store';
import { BookingSearchResult, User } from 'src/app/models/user.model';
import {
  userGetUserBookingsSuccess,
  userGetUserSuccess,
  userLoginSuccess,
  userVerifyRequired,
} from '../actions/user.action';
import { N0VerificationResponse } from '@models/sms-validation.model';

export interface State {
  bookings: BookingSearchResult[] | null;
  loggedInUser: User | null;
  mfa?: N0VerificationResponse | null;
}

export const INITIAL_STATE: State = {
  bookings: null,
  loggedInUser: null,
};

const reducer = createReducer(
  INITIAL_STATE,
  on(
    userGetUserSuccess,
    (currentState, action): State => ({
      ...currentState,
      loggedInUser: action.user,
    }),
  ),

  on(
    userGetUserBookingsSuccess,
    (currentState, action): State => ({
      ...currentState,
      bookings: action.payload,
    }),
  ),

  on(
    bookingCompleteBookingSuccess,
    (state): State => ({
      ...state,
      bookings: null,
    }),
  ),

  on(
    userVerifyRequired,
    (state, action): State => ({
      ...state,
      mfa: action.user.loginVerifyResponse,
    }),
  ),

  on(
    userLoginSuccess,
    (state, _action): State => ({
      ...state,
      mfa: undefined,
    }),
  ),
);

export const userReducer = (state: State, action: Action): State =>
  reducer(state, action);
